var React = require('react');

function ShieldTick (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"#73004C","strokeLinecap":"round","strokeLinejoin":"round","strokeMiterlimit":"10","strokeWidth":"2","d":"m21 12-6 8-4-3m5-15c.9565 0 1.6261 3.938 5.0696 4.9035C24.6087 7.9655 27 7 27 7v11c0 5.6-8.8 12-11 12-2.2 0-11-6.4-11-12V7s2.3913.9655 5.9304-.0965C14.3739 5.9379 15.0435 2 16 2Z"}));
}

ShieldTick.defaultProps = {"width":"32","height":"32","fill":"none","viewBox":"0 0 32 32"};

module.exports = ShieldTick;

ShieldTick.default = ShieldTick;
